<template>
  <div>
    <GoogleMap api-key="AIzaSyDgdpbzUzOXp0h2TEYso4c-k6YHM9ZOf3I" v-if="center" style="width: 100%; height: 500px" :center="center" :zoom="15">
      <Marker :key="index" v-for="(m, index) in locationMarkers" :position="m.position" style="width: 25px; height: 30px"
        :icon="{ url: '@/assets/images/marker1.png' }"
        :options="{ position: center }"
        ></Marker>
    </GoogleMap>
  </div>
</template>
 
<script>
import axios from "axios";
import { GoogleMap, Marker } from "vue3-google-map";

export default {
  components: { GoogleMap, Marker },
  props: { city: String, totalCount: Number },
  name: "AddGoogleMap",
  computed: {
    zoom() {
      return window.innerWidth > 700 ? 13 : 11;
    },
    link() {
      return `https://maps.googleapis.com/maps/api/geocode/json?address=${this.city}&key=AIzaSyDgdpbzUzOXp0h2TEYso4c-k6YHM9ZOf3I`   //AIzaSyASAAMBcxrVDXo12EIC5ksbPOA_CCCKwDw
    }
  },
  data() {
    return {
      center: {
        lat: 12.9715987,
        lng: 77.5945627,
      },
      locationMarkers: [
        // { position: { lat: 28.5841168, lng: 77.3973942 } },
        // { position: { lat: 28.5700706, lng: 77.3891427 } },
        // { position: { lat: 28.5745096, lng: 77.3905778 } },
        // { position: { lat: 28.6060242, lng: 77.4296615 } },
        // { position: { lat: 28.5797807, lng: 77.3657104 } },
      ],
      locPlaces: [],
      existingPlace: null,
    };
  },

  mounted() {
    // this.locateGeoLocation();    // for curent location
    this.getRandomCords();
  },
  watch: {
    city() {
      this.getRandomCords();
    }
  },
  methods: {
    async getRandomCords() {
      let self = this;
      await axios
        .get(this.link)
        .then(function (response) {
          // handle success
          let cords = response.data.results[0].geometry.location;
          self.center = {
            lat: cords.lat,
            lng: cords.lng,
          };
          let temp = [];
          for (var i = 0; i < self.totalCount; i++) {
            var randomGeoPoints = self.generateRandomPoints(self.center, 10000);
            // console.log(randomGeoPoints);
            temp.push({ position: randomGeoPoints });
          }
          self.locationMarkers = temp;
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
    initMarker(loc) {
      this.existingPlace = loc;
    },
    addLocationMarker() {
      if (this.existingPlace) {
        const marker = {
          lat: this.existingPlace.geometry.location.lat(),
          lng: this.existingPlace.geometry.location.lng(),
        };
        this.locationMarkers.push({ position: marker });
        this.locPlaces.push(this.existingPlace);
        this.center = marker;
        this.existingPlace = null;
      }
    },
    generateRandomPoints(center, radius) {
      var x0 = center.lng;
      var y0 = center.lat;
      // Convert Radius from meters to degrees.
      var rd = radius / 111300;

      var u = Math.random();
      var v = Math.random();

      var w = rd * Math.sqrt(u);
      var t = 2 * Math.PI * v;
      var x = w * Math.cos(t);
      var y = w * Math.sin(t);

      var xp = x / Math.cos(y0);

      // Resulting point.
      return { lat: y + y0, lng: xp + x0 };
    },
    //     handleMarkerClick(e){
    //         console.log(e);
    // // center = m.position
    //     },
    locateGeoLocation: function () {
      navigator.geolocation.getCurrentPosition((res) => {
        this.center = {
          lat: res.coords.latitude,
          lng: res.coords.longitude,
        };
      });
    },
  },
};
</script>